import { KYCFileType } from '@dealstack/shared/lib/generated';
import { StepType } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ManageKYC/types';

export interface UploadFileOptions {
	templateIdOverride?: string;
}

export const STEP_TYPE_TO_KYC_FILE_TYPE: Partial<Record<StepType, KYCFileType>> = {
	[StepType.PROOF_OF_IDENTITY]: KYCFileType.PROOF_OF_IDENTITY,
	[StepType.PROOF_OF_ADDRESS]: KYCFileType.PROOF_OF_ADDRESS,
	[StepType.INVESTMENT_VEHICLE]: KYCFileType.INVESTMENT_VEHICLE,
	[StepType.FORM]: KYCFileType.FORM,
};
